export default __webpack_public_path__ + "static/media/multiasset-balancing.17e976eb.jpg";